import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import SmoothScroll from "@/sections/SmoothScroll";
import CustomCursor from "@/sections/CustomCursor";
import Preloader from "@/sections/Preloader";
import Nav from "@/sections/Nav";
import Hero from "@/sections/Hero";
import Legacy from "@/sections/Legacy";
import Hardware from "@/sections/Hardware";
import BlueprintScroll from "@/sections/BlueprintScroll";
import About from "@/sections/About";
import Stats from "@/sections/Stats";
import EditorialMarquee from "@/sections/EditorialMarquee";
import Services from "@/sections/Services";
import Projects from "@/sections/Projects";
import Ongoing from "@/sections/Ongoing";
import Journey from "@/sections/Journey";
import WhyChoose from "@/sections/WhyChoose";
import Gallery from "@/sections/Gallery";
import Testimonials from "@/sections/Testimonials";
import DirectorMessage from "@/sections/DirectorMessage";
import Contact from "@/sections/Contact";
import Heritage from "@/sections/Heritage";
import Footer from "@/sections/Footer";
import WhatsAppFab from "@/sections/WhatsAppFab";

function Home() {
    return (
        <>
            <Preloader />
            <SmoothScroll />
            <CustomCursor />
            <div className="noise-overlay" aria-hidden />

            <Nav />

            <main data-testid="home-main">
                <Hero />
                <Legacy />
                <Hardware />
                <BlueprintScroll />
                <About />
                <Stats />
                <EditorialMarquee
                    text="Building Landmarks · Creating Legacies · Since 1984"
                    speed={26}
                />
                <Services />
                <Projects />
                <Ongoing />
                <Journey />
                <WhyChoose />
                <Gallery />
                <EditorialMarquee
                    text="Crafted in Bangalore · With Trust · With Integrity"
                    speed={22}
                    outlined={false}
                />
                <Testimonials />
                <DirectorMessage />
                <Contact />
                <Heritage />
            </main>

            <Footer />
            <WhatsAppFab />
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
